import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../store/Slices/AuthSlice';
import '../styles/Auth.css';
import { resetSchema } from '../utils/Schema';
import { passwordIcon } from '../utils/svgs';
import { errorNotify, successNotify } from '../utils/toast';

const DefaultPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { loading, error } = useSelector((state) => state.auth);

    const [showPassword, setShowPassword] = useState(false);
    const [confirmShowPassword, setConfirmShowPassword] = useState(false);

    const handleChangePassword = async (values, { setSubmitting }) => {
        try {
            const resultAction = await dispatch(changePassword({
                password: values.password,
                confirm_password: values.confirm_password,
            }));

            if (changePassword.fulfilled.match(resultAction)) {
                localStorage.removeItem('fms-maintenance-details');
                localStorage.removeItem('fms-maintenance-token');
 
                successNotify('Password successfully Changed');
                navigate('/');
            }
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='main_auth_screen'>
            <Container fluid>
                <Row>
                    <Col md={7} className='auth_left'>
                        <div>
                            <h2>Maintenance</h2>
                            <h6>Change Default Password</h6>
                        </div>
                    </Col>
                    <Col md={5} className='auth_col'>
                        <div className='auth_form'>
                            <div>
                                <h1>Change Your Password</h1>
                                <p>You are logging in with the default password, to proceed change your password for better security.</p>

                                <div className='auth_inputs'>
                                    <Formik
                                        initialValues={{
                                            password: '',
                                            confirm_password: ''
                                        }}
                                        validationSchema={resetSchema}
                                        onSubmit={handleChangePassword}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div className='mb-3'>
                                                    <div className="form-group password-field">
                                                        {passwordIcon}
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Field
                                                                type={showPassword ? 'text' : 'password'}
                                                                name='password'
                                                                placeholder='Enter New Password'
                                                                className="form-control"
                                                            />
                                                            <span
                                                                className="password-toggle-icon"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="password" component="div" className="error-message" />
                                                </div>

                                                <div className='mb-3'>
                                                    <div className="form-group password-field">
                                                        {passwordIcon}
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Field
                                                                type={confirmShowPassword ? 'text' : 'password'}
                                                                name='confirm_password'
                                                                placeholder='Enter Confirm Password'
                                                                className="form-control"
                                                            />
                                                            <span
                                                                className="password-toggle-icon"
                                                                onClick={() => setConfirmShowPassword(!confirmShowPassword)}
                                                            >
                                                                {confirmShowPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="confirm_password" component="div" className="error-message" />
                                                </div>

                                                {error && (
                                                    <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
                                                        {error}
                                                    </div>
                                                )}

                                                <button
                                                    type='submit'
                                                    disabled={isSubmitting || loading}
                                                >
                                                    {loading || isSubmitting ? 'Submitting...' : 'Continue'}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DefaultPassword